import React from 'react';
import { Provider } from 'react-redux';
import store from '../../state';
import TemplatePatternEditor from './TemplatePatternEditor';

// Wrapper that allows placing the template pattern editor anywhere on the
// site. Duty functions and availability codes are loaded from Redux.
const TemplatePatternEditorStandalone = props => (
  <Provider store={store}>
    <TemplatePatternEditor {...props} />
  </Provider>
);

export default TemplatePatternEditorStandalone;
